import { render, staticRenderFns } from "./TenderImageColumn.vue?vue&type=template&id=5f4cd3a6&scoped=true"
import script from "./TenderImageColumn.vue?vue&type=script&lang=js"
export * from "./TenderImageColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cd3a6",
  null
  
)

export default component.exports